/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddStartup = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        startupName: '',
        description: '',
        year: '',
        state: '',
        address: '',
        program: '',
        website: '',
        logo: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.startupName || !formData.firstName) {
            toast.error("Startup Name and Founder Name are required!");
            return;
        }

        setLoading(true);
        const data = new FormData();
        
        // Auto-generate email and mobile to satisfy backend unique constraints when not provided
        const submitEmail = formData.email || `startup_${Date.now()}@temp.com`;
        const submitMobile = formData.mobile || `999${Math.floor(1000000 + Math.random() * 9000000)}`;
        
        const payload = {
            ...formData,
            email: submitEmail,
            mobile: submitMobile
        };

        for (const key in payload) {
            if (payload[key] !== null) {
                data.append(key, payload[key]);
            }
        }

        try {
            await postRequest('startups/admin', data);
            toast.success('Startup added successfully!');
            navigate('/startups');
        } catch (error) {
            console.error('Failed to add startup:', error);
            toast.error(error?.response?.data?.message || error?.message || 'Error occurred while creating startup.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4'>
                <h4 className='text-white font-weight-bold'>Add Startup Profile</h4>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <h5 className="border-bottom pb-2">Founder Details</h5>
                    </div>
                    <div className='col-md-12 form-group'>
                        <label className='admin-label font-weight-bold'>Founder Name *</label>
                        <input type='text' name='firstName' className='form-control' value={formData.firstName} onChange={handleChange} placeholder='Enter full name' required />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Mobile Number</label>
                        <input type='text' name='mobile' className='form-control' value={formData.mobile} onChange={handleChange} placeholder='Enter mobile number' />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Email Address</label>
                        <input type='email' name='email' className='form-control' value={formData.email} onChange={handleChange} placeholder='Enter email address' />
                    </div>
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Founder Address</label>
                        <input type='text' name='address' className='form-control' value={formData.address} onChange={handleChange} placeholder="e.g. 123 Main St, City" />
                    </div>
                    <div className='col-12 mb-3 mt-4'>
                        <h5 className="border-bottom pb-2">Startup Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Startup Name *</label>
                        <input type='text' name='startupName' className='form-control' value={formData.startupName} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Cohort Year (e.g. 2019-2020)</label>
                        <input type='text' name='year' className='form-control' value={formData.year} onChange={handleChange} placeholder="e.g. 2019-2020" />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Program</label>
                        <select name='program' className='form-control' value={formData.program} onChange={handleChange}>
                            <option value="">Select Program</option>
                            <option value="Seed">Seed</option>
                            <option value="Pre Seed">Pre Seed</option>
                            <option value="SOP">SOP</option>
                        </select>
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Incorporation State</label>
                        <input type='text' name='state' className='form-control' value={formData.state} onChange={handleChange} placeholder="e.g. Madhya Pradesh" />
                    </div>
                    <div className='col-md-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Website URL</label>
                        <input type='text' name='website' className='form-control' value={formData.website} onChange={handleChange} placeholder="https://example.com" />
                    </div>
                    
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Description</label>
                        <textarea name='description' className='form-control' rows="3" value={formData.description} onChange={handleChange} placeholder="About the startup..."></textarea>
                    </div>

                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Startup Logo</label>
                        <input type='file' name='logo' className='form-control filebg' onChange={handleChange} accept="image/*" />
                    </div>
                </div>
                
                <div className='mt-4 text-right'>
                    <button type="button" className="btn btn-secondary mr-2" onClick={() => navigate('/startups')}>Cancel</button>
                    <button type="submit" className='btn addbtn pl-4 pr-4' disabled={loading}>
                        {loading ? 'Creating...' : 'Add Startup'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddStartup;
